import { DatePicker, Form, Image, Input, Select } from "antd";
import TextArea from "antd/lib/input/TextArea";
import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Authorization from "../../../../component/Authorization";
import MPageHeader from "../../../../component/PageHeader";
import { SpinContext } from "../../../../component/Spin/spin.context";
import { spinActions } from "../../../../component/Spin/spin.reducer";
import { dialog } from "../../../../helper/dialog";
import helper from "../../../../helper/helper";
import { Task, TaskStatus, TaskUI } from "../entity/task.model";
import { taskService } from "../service/task.service";

function EditTask() {
  const { Option } = Select;
  let { taskId } = useParams();
  let navigate = useNavigate();
  const [task, setTask] = useState<TaskUI>();
  const { dispatch } = useContext(SpinContext);

  function handleChange(value: TaskStatus) {
    setTask({ ...task!, status: value });
  }

  useEffect(() => {
    if (taskId) {
      dispatch({ type: spinActions.BLOCK });
      taskService
        .getTask(taskId)
        .then((_task: TaskUI) => {
          setTask(_task);
          dispatch({ type: spinActions.UNBLOCK });
        })
        .catch(() => {
          dispatch({ type: spinActions.UNBLOCK });
        });
    }

    return () => {
      setTask(undefined);
    };
  }, [taskId]);

  const onFinish = async (_task: Task) => {
    if (task?.uuid) {
      _task.uuid = task.uuid;
      await taskService.editTask(_task);
    }

    dialog.success(`Даалгавар амжилттай шинэчлэгдлээ.`);

    navigate("/tasks");
  };

  return (
    <>
      <MPageHeader crumbs={["Даалгаварууд", task?.uuid ?? ""]} />
      <div className="content">
        <div className="card">
          <div className="card-header header-elements-inline">
            <h5 className="card-title">Даалгаварын мэдээлэл</h5>
          </div>
          <div className="card-body">
            {task && (
              <fieldset disabled={!helper.hasRoles(["task-full"])}>
                <Form initialValues={task} onFinish={onFinish}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Хэрэглэгчийн нэр</label>
                        <Form.Item name="username">
                          <Input readOnly={true} />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Огноо</label>
                        <Form.Item name="date">
                          <DatePicker disabled style={{ width: "100%" }} />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <label>Даалгаврын төрөл</label>
                    <Form.Item name="taskType">
                      <Select
                        placeholder="Төрөл сонгох"
                        onChange={handleChange}
                        disabled
                      >
                        <Option value={"STALL"}>
                          {helper.getTaskType("STALL")}
                        </Option>
                        <Option value={"SALES"}>
                          {helper.getTaskType("SALES")}
                        </Option>
                      </Select>
                    </Form.Item>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Төлөв сонгох</label>
                        <Form.Item
                          name="status"
                          rules={[
                            {
                              required: true,
                              message: "Төлвийг сонгоно уу.",
                            },
                          ]}
                        >
                          <Select
                            placeholder="Төлөв сонгох"
                            onChange={handleChange}
                            disabled={task.taskType === "SALES"}
                          >
                            <Option value={TaskStatus.NEW}>
                              {helper.getTaskStatus(TaskStatus.NEW)}
                            </Option>
                            <Option value={TaskStatus.DECLINED}>
                              {helper.getTaskStatus(TaskStatus.DECLINED)}
                            </Option>
                            <Option value={TaskStatus.APPROVED}>
                              {helper.getTaskStatus(TaskStatus.APPROVED)}
                            </Option>
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Харилцагч</label>
                        <Form.Item name="companyName">
                          <Input readOnly={true} />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  {task.status === TaskStatus.DECLINED &&
                    task.taskType === "STALL" && (
                      <div className="form-group">
                        <label>Цуцласан тайлбар</label>
                        <Form.Item name="description">
                          <TextArea rows={5} />
                        </Form.Item>
                      </div>
                    )}
                  {task.taskType === "STALL" && <label>Өрөлтийн зураг</label>}
                  {task?.stalls.length > 0 ? (
                    task?.stalls?.map((stall) => (
                      <div className="row" key={stall.uuid}>
                        <div className="col-md-6">
                          <div className="card">
                            <div className="card-img-actions">
                              <Image
                                className="card-img img-fluid"
                                src={stall.beforeImageFile}
                              />
                            </div>
                            <div className="card-body">
                              <div className="d-flex align-items-start flex-nowrap">
                                <div>
                                  <div className="font-weight-semibold mr-2">
                                    Өмнө
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="card">
                            <div className="card-img-actions">
                              <Image
                                className="card-img img-fluid"
                                src={stall.afterImageFile}
                              />
                            </div>
                            <div className="card-body">
                              <div className="d-flex align-items-start flex-nowrap">
                                <div>
                                  <div className="font-weight-semibold mr-2">
                                    Дараах
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="text-muted">Өрөлт олдсонгүй.</div>
                  )}
                  <Authorization roles={["task-full"]}>
                    <div className="text-right">
                      <button type="submit" className="btn btn-primary">
                        Хадгалах <i className="icon-floppy-disk ml-2" />
                      </button>
                    </div>
                  </Authorization>
                </Form>
              </fieldset>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default EditTask;
